import React, { useState } from 'react';
import { Box, useTheme } from '@mui/material';
import { observer } from 'mobx-react-lite';
import IconTriangle from 'icons/iconTriangle';

export default observer(function ExpandContainer({
  children,
}: {
  children: React.ReactNode;
}) {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box
      sx={{
        position: 'relative',
        width: 1,
        pb: 8,
        overflow: 'visible',
      }}
    >
      <IconTriangle
        extColor={theme.palette.customBackgrounds.contrast}
        style={{
          position: 'absolute',
          left: '50%',
          bottom: 0,
          transform: isOpen
            ? 'translate(-50%, 0%)'
            : 'rotate(180deg) translate(100%, -100%)',
        }}
      ></IconTriangle>
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          width: 1,
          height: '1px',
          bgcolor: 'customBackgrounds.contrast',
        }}
      ></Box>
      <Box
        onClick={() => setIsOpen(!isOpen)}
        sx={{
          display: 'flex',
          alignItems: 'start',
          position: 'absolute',
          bottom: 0,
          width: 1,
          cursor: 'pointer',
          height: 30,
          transform: 'translateY(65%)',
        }}
      ></Box>
      {isOpen && children}
    </Box>
  );
});
